import * as Yup from "yup";
import {
  Backdrop,
  Box,
  CircularProgress,
  Container,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import {
  Log,
  MerchantUserActions,
  getCreateMerchantUserOptions,
} from "../../services/services";
import FormDialog from "../../components/FormDialog";

const CreateNewMerchantUser = ({ open, onClose }) => {
  const [options, setOptions] = useState();
  const [optLoaded, setOptLoaded] = useState(false);
  const [googleAccountUser, setGoogleAccountUser] = useState(false);

  const handleSubmit = async (values, { setSubmitting }) => {
    const roleOption = options.role.filter((item) => item?.toLowerCase() === "owner")?.[0];
    const groupOption = options.group.filter((item) => item?.name?.toLowerCase() === "supermerchantuser")?.[0];
    const departmentOption = options.department.filter((item) => item?.department?.toLowerCase() === "merchant")?.[0];
    const salutationOption = options.salutation.filter((item) => item?.salutation?.toLowerCase()?.includes('mrs'))?.[0];
    let map = {
      ...values,
      email: values.email?.trim()?.toLowerCase(),
      business_entities: values.business_entities.map(({ id }) => id) || [],
      role: roleOption,
      group: groupOption?.id,
      department: departmentOption?.id,
      salutation: salutationOption?.id,
    };
    map["is_google"] = googleAccountUser;
    if (googleAccountUser) {
      map["temporary_password"] = "";
    }
    Log.info('Click button [Submit] - Add new Merchant User', map)
    await MerchantUserActions({ action: "add", params: map }, onClose);
    setSubmitting(false);
  };

  useEffect(() => {
    getCreateMerchantUserOptions(setOptions, setOptLoaded);
  }, []);

  const tooltipContent = (
    <Box>
      <Typography>
        Password requirements: <br />
        - Minimum 8 characters <br />
        - At least 1 Uppercase <br />
        - At least 1 Lowercase <br />
        - At least 1 Special Character (!@#$%^&*) <br />
        <br />
      </Typography>
    </Box>
  );

  return (
    <Container>
      {optLoaded ? (
        <Box>
          <Formik
            initialValues={{
              email: "",
              salutation: "",
              first_name: "",
              last_name: "",
              contact_number: "",
              group: "",
              // business_entity: "",
              department: "",
              role: "",
              business_entities: []
              // is_google: googleAccountUser,
              // temporary_password: "",
            }}
            onSubmit={handleSubmit}
            validationSchema={Yup.object().shape({
              email: Yup.string().email("Invalid email").required("Required"),
              // salutation: Yup.string().required("Salutation is required"),
              first_name: Yup.string().required("First name is required").trim(),
              last_name: Yup.string().required("Last name is required").trim(),
              // group: Yup.string().required("Group is required"),
              // business_entity: Yup.string().required(
              //   "business_entity is required"
              // ),
              // department: Yup.string().required("Department is required"),
              // role: Yup.string().required("Role is required"),
            })}
          >
            {(props) => {
              const {
                values,
                touched,
                errors,
                isSubmitting,
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue,
                setFieldError,
              } = props;
              return (
                <FormDialog
                  open={open}
                  onClose={onClose}
                  title="Create A New Account"
                  scroll="paper"
                  handleSubmit={handleSubmit}
                  loading={isSubmitting}
                >
                  <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                    <Grid
                      container
                      rowSpacing={2}
                      columnSpacing={3}
                      sx={{
                        alignItems: "center",
                        justifyContent: "center",
                        py: 2,
                        px: 2
                      }}
                    >
                      <Grid item md={2} xs={2}>
                        <Typography
                          variant="subtitle1"
                          sx={{ textAlign: "right" }}
                        >
                          Email*
                        </Typography>
                      </Grid>
                      <Grid item md={4} xs={4}>
                        <TextField
                          margin="normal"
                          required
                          fullWidth
                          id="email"
                          name="email"
                          label="Email"
                          size="small"
                          color="secondary"
                          value={values.email}
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          onBlur={handleBlur}
                          error={Boolean(touched.email && errors.email)}
                          helperText={touched.email && errors.email}
                          disabled={isSubmitting}
                        />
                      </Grid>
                      {/* <Grid item md={2} xs={2}>
                        <Typography
                          variant="subtitle1"
                          sx={{ textAlign: "right" }}
                        >
                          Salutation*
                        </Typography>
                      </Grid>
                      <Grid item md={4} xs={4}>
                        <TextField
                          margin="normal"
                          required
                          select
                          id="salutation"
                          name="salutation"
                          size="small"
                          color="secondary"
                          fullWidth
                          label="Salutation"
                          value={values.salutation}
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          onBlur={handleBlur}
                          error={Boolean(touched.salutation && errors.salutation)}
                          helperText={touched.salutation && errors.salutation}
                          disabled={isSubmitting}
                        >
                          {options.salutation.map((sal) => (
                            <MenuItem key={sal.id} value={sal.id}>
                              {sal.salutation}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid> */}
                      <Grid item md={2} xs={2}>
                        <Typography
                          variant="subtitle1"
                          sx={{ textAlign: "right" }}
                        >
                          First Name*
                        </Typography>
                      </Grid>
                      <Grid item md={4} xs={4}>
                        <TextField
                          margin="normal"
                          required
                          fullWidth
                          id="first_name"
                          name="first_name"
                          label="First Name"
                          size="small"
                          color="secondary"
                          value={values.first_name}
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          onBlur={handleBlur}
                          error={Boolean(touched.first_name && errors.first_name)}
                          helperText={touched.first_name && errors.first_name}
                          disabled={isSubmitting}
                        />
                      </Grid>
                      <Grid item md={2} xs={2}>
                        <Typography
                          variant="subtitle1"
                          sx={{ textAlign: "right" }}
                        >
                          Last Name*
                        </Typography>
                      </Grid>
                      <Grid item md={4} xs={4}>
                        <TextField
                          margin="normal"
                          required
                          fullWidth
                          id="last_name"
                          name="last_name"
                          label="Last Name"
                          size="small"
                          color="secondary"
                          value={values.last_name}
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          onBlur={handleBlur}
                          error={Boolean(touched.last_name && errors.last_name)}
                          helperText={touched.last_name && errors.last_name}
                          disabled={isSubmitting}
                        />
                      </Grid>
                      <Grid item md={2} xs={2}>
                        <Typography
                          variant="subtitle1"
                          sx={{ textAlign: "right" }}
                        >
                          Contact Number
                        </Typography>
                      </Grid>
                      <Grid item md={4} xs={4}>
                        <TextField
                          margin="normal"
                          fullWidth
                          id="contact_number"
                          name="contact_number"
                          label="Contact Number"
                          size="small"
                          color="secondary"
                          value={values.contact_number}
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          onBlur={handleBlur}
                          error={Boolean(
                            touched.contact_number && errors.contact_number
                          )}
                          helperText={
                            touched.contact_number && errors.contact_number
                          }
                          disabled={isSubmitting}
                        />
                      </Grid>
                      {/* <Grid item md={2} xs={2}>
                        <Typography
                          variant="subtitle1"
                          sx={{ textAlign: "right" }}
                        >
                          Department*
                        </Typography>
                      </Grid>
                      <Grid item md={4} xs={4}>
                        <TextField
                          margin="normal"
                          required
                          select
                          id="department"
                          name="department"
                          label="Department"
                          size="small"
                          color="secondary"
                          value={values.department}
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          onBlur={handleBlur}
                          error={Boolean(touched.department && errors.department)}
                          helperText={touched.department && errors.department}
                          disabled={isSubmitting}
                          fullWidth
                        >
                          {options.department.map((item) => (
                            <MenuItem key={item.id} value={item.id}>
                              {item.department}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid> */}
                      {/* <Grid item md={2} xs={2}>
                        <Typography
                          variant="subtitle1"
                          sx={{ textAlign: "right" }}
                        >
                          Group*
                        </Typography>
                      </Grid>
                      <Grid item md={4} xs={4}>
                        <TextField
                          margin="normal"
                          required
                          select
                          id="group"
                          name="group"
                          label="Group"
                          size="small"
                          color="secondary"
                          value={values.group}
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          onBlur={handleBlur}
                          error={Boolean(touched.group && errors.group)}
                          helperText={touched.group && errors.group}
                          disabled={isSubmitting}
                          fullWidth
                        >
                          {options.group.map((group) => (
                            <MenuItem key={group.id} value={group.id}>
                              {group.name}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid> */}
                      <Grid item md={2} xs={2}>
                        <Typography
                          variant="subtitle1"
                          sx={{ textAlign: "right" }}
                        >
                          Business Entities
                        </Typography>
                      </Grid>
                      <Grid item md={4} xs={4}>
                        <Select
                          id={"business_entities"}
                          name={"business_entities"}
                          getOptionLabel={(option) => option.business_name}
                          getOptionValue={(option) => option.id}
                          closeMenuOnSelect={false}
                          isMulti
                          options={options.business_entity}
                          value={values.business_entities}
                          onChange={(event) => setFieldValue("business_entities", event)}
                          styles={{
                            control: (provided) => ({
                              ...provided,
                              minHeight: "40px",
                            }),
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                          }}
                          menuPortalTarget={document.body}
                        />
                      </Grid>
                      {/* <Grid item md={2} xs={2}>
                        <Typography
                          variant="subtitle1"
                          sx={{ textAlign: "right" }}
                        >
                          Role*
                        </Typography>
                      </Grid>
                      <Grid item md={4} xs={4}>
                        <TextField
                          margin="normal"
                          required
                          select
                          id="role"
                          name="role"
                          label="Role"
                          size="small"
                          color="secondary"
                          value={values.role}
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          onBlur={handleBlur}
                          error={Boolean(touched.role && errors.role)}
                          helperText={touched.role && errors.role}
                          disabled={isSubmitting}
                          fullWidth
                        >
                          {options.role.map((item) => (
                            <MenuItem key={item} value={item}>
                              {item}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid> */}

                      <Grid item md={2} xs={2}>
                      </Grid>
                      <Grid item md={4} xs={4}>
                      </Grid>

                      {/* <Grid item md={2} xs={2}>
                        <Typography
                          variant="subtitle1"
                          sx={{
                            textAlign: "right",
                          }}
                        >
                          Temporary Password{!googleAccountUser && "*"}
                        </Typography>
                      </Grid>
                      <Grid item md={3.5} xs={3.5}>
                        <Field
                          id="temporary_password"
                          name="temporary_password"
                          label="Temporary Password"
                          validate={(value) => {
                            if (!googleAccountUser) {
                              if (value.length < 1) {
                                return "Temporary password is required";
                              }
                              //^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$
                              //^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})
                              if (
                                !/(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*#?&^_-]).{8,}/i.test(
                                  value
                                )
                              ) {
                                return "Password does not meet the minimum requirements.";
                              }
                            }
                          }}
                          render={({ field }) => (
                            <TextField
                              margin="normal"
                              fullWidth
                              id="temporary_password"
                              name="temporary_password"
                              label="Temporary Password"
                              type="password"
                              size="small"
                              color="secondary"
                              disabled={googleAccountUser || isSubmitting}
                              value={values.temporary_password}
                              onChange={(e) => {
                                handleChange(e);
                              }}
                              onBlur={handleBlur}
                              error={Boolean(
                                touched.temporary_password &&
                                  errors.temporary_password
                              )}
                              helperText={
                                touched.temporary_password &&
                                errors.temporary_password
                              }
                            />
                          )}
                        />
                      </Grid>
                      <Grid item md={0.5} xs={0.5}>
                        <CustomTooltip
                          content={tooltipContent}
                          styles={{ maxWidth: "none" }}
                          placement="bottom"
                        />
                      </Grid>
                      <Grid item md={6} xs={6} />
                      <Grid
                        item
                        md={2}
                        xs={2}
                        sx={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <Checkbox
                          checked={googleAccountUser}
                          onChange={(e) => {
                            setGoogleAccountUser(e.target.checked);

                            if (e.target.checked) {
                              setFieldError("temporary_password");
                            }
                          }}
                        />
                      </Grid>
                      <Grid
                        item
                        md={4}
                        xs={4}
                        sx={{ display: "flex", justifyContent: "flex-start" }}
                      >
                        <Typography
                          variant="subtitle1"
                          sx={{ textAlign: "right" }}
                        >
                          Google Account User
                        </Typography>
                      </Grid> */}
                    </Grid>
                  </Form>
                </FormDialog>
              );
            }}
          </Formik>
        </Box>
      ) : (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
    </Container>
  );
};

export default CreateNewMerchantUser;
